"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageActionsPersist = void 0;
var react_1 = require("react");
var LoggerFactory_1 = require("../utils/LoggerFactory");
var PageActionsProvider_1 = require("./PageActionsProvider");
var LOG = LoggerFactory_1.LoggerFactory.create('PageActions');
/**
 * Hook to add duration storage functionality to a metrics measurement. Useful when an action duration need
 * to be persisted accross multiple pages or you want to avoid abandoned events due to a user quicly moving
 * to a different page
 *
 * @returns
 */
var usePageActionsPersist = function () {
    var _a = (0, PageActionsProvider_1.usePageActions)(), startAction = _a.startAction, endAction = _a.endAction, trackAction = _a.trackAction;
    var getStorageKey = function (definition, uniqueID) {
        var key = typeof definition === 'string' ? definition : definition.id;
        return uniqueID ? "".concat(key, "_startTime::").concat(uniqueID) : "".concat(key, "_startTime");
    };
    /**
     * @deprecated Use startActionPersist instead
     */
    var measureActionPersist = (0, react_1.useCallback)(function (definition, data, uniqueID, options) {
        var actionKey = getStorageKey(definition, uniqueID);
        try {
            // to avoid abandoned events due to user leaving the page before we track it, we use localStorage to persist the start time
            var dataToPersist = JSON.stringify({
                time: Date.now(),
                initialData: data || {},
                initialOptions: options
            });
            localStorage.setItem(actionKey, dataToPersist);
        }
        catch (e) {
            LOG.debug("This browser does not support session storage, therefore the ".concat(actionKey, " action duration will not be persisted"), e);
            // fallback to normal tracking
            startAction(definition, data, undefined, options);
        }
    }, [startAction]);
    /**
     * @deprecated Use endActionPersist instead
     */
    var recordActionPersist = (0, react_1.useCallback)(function (definition, data, uniqueID, options) {
        var actionKey = getStorageKey(definition, uniqueID);
        try {
            // If we don't find the item in local storage, this means users continue the process on a different browser
            // or step 1 of the process was not even executed. We track the action bug flag it to exclude it from reports
            if (!localStorage.getItem(actionKey)) {
                trackAction(definition, __assign(__assign({}, data), { duration: 0, type: 'tracked', incomplete_measure: "Measurement could not be completed. It is possible the user switched devices/browsers during the process" }));
                return;
            }
            // Calculate the elapsed time
            var dataPersisted = JSON.parse(localStorage.getItem(actionKey));
            var time = dataPersisted.time, initialData = dataPersisted.initialData, initialOptions = dataPersisted.initialOptions;
            var startTime = new Date(parseInt(time));
            var now = new Date();
            var duration = now.getTime() - startTime.getTime();
            trackAction(definition, __assign(__assign(__assign({}, data), initialData), { duration: duration, type: 'tracked' }), __assign(__assign({}, options), initialOptions), 
            // We need to know when the action was actually recorded so we can confidently delete the data from storage
            // This callback accounts for situations where a persisted action has started and then finished by instrumentation
            // but the page calling endAction is redirecting for instance resulting in loosing the initial properties passed to
            // the startAction function
            function (reporter, context) {
                LOG.debug('[PageActions] Persisted action measured sucessfully >>>>', { reporter: reporter, context: context });
                localStorage.removeItem(actionKey);
            });
        }
        catch (e) {
            LOG.debug("[PageActions] This browser does not support session storage, therefore the ".concat(actionKey, " action duration was recorded without duration persistance"), e);
            endAction(definition, data);
        }
    }, [endAction, trackAction]);
    var startActionPersist = measureActionPersist;
    var endActionPersist = recordActionPersist;
    return {
        /**
         * @deprecated Use startActionPersist instead
         */
        measureActionPersist: measureActionPersist,
        /**
         * @deprecated Use endActionPersist instead
         */
        recordActionPersist: recordActionPersist,
        startActionPersist: startActionPersist,
        endActionPersist: endActionPersist
    };
};
exports.usePageActionsPersist = usePageActionsPersist;
